import domReady from '@wordpress/dom-ready';
// import { _x } from '@wordpress/i18n';

domReady(() => {
  const FWP = window.FWP;

  document.addEventListener('facetwp-loaded', function () {
    const filtersSelection = document.querySelectorAll('.filtersSelection');
    if ('' === FWP.buildQueryString()) {
      filtersSelection.forEach((selection) => {
        selection.classList.add('sectionHidden');
      });
    } else {
      filtersSelection.forEach((selection) => {
        selection.classList.remove('sectionHidden');
      });
    }
  });

  /* mobile toggle */

  // const filtersToggle = document.getElementById('filtersToggle');
  // const filtersWrapper = document.getElementById('filtersWrapper');
  // const filtersApply = document.querySelectorAll('.applyFilters');

  // function closeFilters() {
  //   filtersWrapper.classList.remove('opened');
  //   filtersToggle.querySelector('span').textContent = _x(
  //     'Show filters',
  //     'filters toggle btn',
  //     'vtx'
  //   );
  //   filtersToggle.setAttribute('aria-expanded', 'true');
  // }

  // function openFilters() {
  //   filtersWrapper.classList.add('opened');
  //   filtersToggle.querySelector('span').textContent = _x(
  //     'Hide filters',
  //     'filters toggle btn',
  //     'vtx'
  //   );
  //   filtersToggle.setAttribute('aria-expanded', 'true');
  // }

  // if (filtersToggle) {
  //   filtersToggle.addEventListener('click', function () {
  //     if (filtersWrapper.classList.contains('opened')) {
  //       closeFilters();
  //     } else {
  //       openFilters();
  //     }
  //   });
  // }

  // if (0 < filtersApply.length) {
  //   filtersApply.forEach(function (applyBtn) {
  //     applyBtn.addEventListener('click', function () {
  //       window.FWP.refresh();
  //       closeFilters();
  //     });
  //   });
  // }

  document.addEventListener('facetwp-loaded', function () {
    window.scrollTo(0, 0);
  });
});
